import { createSelector } from 'reselect';
import { getCollectionsNew } from '../collections';

export const getCollectionShopMeta = createSelector([getCollectionsNew], (collection) => ({
  shopActive: collection.shopActive,
  _productPricingList: collection._productPricingList,
  showOnlyPurchasedPrints: collection.showOnlyPurchasedPrints,
  salesAutomationConfig: collection.salesAutomationConfig,
  shopCtaPlacement: collection.shopCtaPlacement
}));
